import config from './config.js'

export default {

  list: function(ctrl,type,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/data/markup?type=' + encodeURIComponent(type) + '&lang=*','Vorlagen auflisten',cb_success);
  },

  load: function(ctrl,id,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/data/markup/' + encodeURIComponent(id),'Vorlage laden',cb_success);
  },

  save: function(ctrl,template,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/data/markup/' + encodeURIComponent(template.map_id),'Vorlage speichern',JSON.stringify(template),cb_success);
  },

  delete: function(ctrl,id,cb_success) {
    config.delete(ctrl,config.baseUrl + 'rest/data/markup/' + encodeURIComponent(id),'Vorlage löschen',cb_success);
  },

  livepreview: function(ctrl,type,oid,template,cb_success) {
    var url = config.baseUrl + 'rest/data/markuppreview?type=' + String(type);
    if (oid !== '') {
      url += '&oid=' + encodeURIComponent(oid);
    }
    config.post(ctrl,url,'Live Preview',template,cb_success,'text');
  },

  previewjson: function(ctrl,type,oid,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/data/markuppreview?id=none&oid=' + encodeURIComponent(oid) + '&data=1&type=' + encodeURIComponent(type),'Live Preview Data',cb_success);
  }
}
